import updateDisplayService from "../services/UpdateDisplayService";
import Cookies from "universal-cookie";

class EulaDisplayLogic {
    constructor() {
        this.EulaTimeStamp = 1674072217573;
    }

    _displayEula = () => {
        updateDisplayService.setMessage("EULA");
        updateDisplayService.setTitle("Terms of service");

        updateDisplayService.onCancel(() => {
            updateDisplayService.clearAll();
            window.location.href = window.location.origin;
        });

        updateDisplayService.onAccept(() => {
            // saves a cookie if the user has accepted the terms with value of timestamp
            document.cookie = `termsOfService=${Date.now()};expires=${new Date(new Date().getTime() + 60 * 60 * 5000000 * 24).toGMTString()};path=/`;
            updateDisplayService.clearAll();
        });
    };

    checkIfTermsOfServcieIsAccepted = () => {
        const cookies = new Cookies();

        const timestampOfTermsOfService = cookies.get("termsOfService");
        if (timestampOfTermsOfService) {
            // if the cookie is older than the set timestamp in the eula we show the eula again
            // this means we updated the eula and want to display it again
            if (parseInt(timestampOfTermsOfService) <= this.EulaTimeStamp)
                this._displayEula();
        }
        // if no cookie is found we display eula
        if (!timestampOfTermsOfService) this._displayEula();
    };
}

const singleton = new EulaDisplayLogic();
export default singleton;
